import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="cart-quantity"
export default class extends Controller {
  static targets = ["input"]
  static values = {
    itemId: Number
  }

  connect() {
    // console.log("CartQuantityController connected")
  }

  increase(event) {
    event.preventDefault()
    const input = this.inputTarget
    const currentValue = parseInt(input.value) || 0
    const max = parseInt(input.max) || 10000
    
    if (currentValue < max) {
      input.value = currentValue + 1
    }
  }

  decrease(event) {
    event.preventDefault()
    const input = this.inputTarget
    const currentValue = parseInt(input.value) || 0
    const min = parseInt(input.min) || 0
    
    if (currentValue > min) {
      input.value = currentValue - 1
    }
  }

  validate(event) {
    const input = event.target
    let value = parseInt(input.value)
    
    if (isNaN(value)) {
      // If the input is empty or invalid, do nothing (allow user to clear input)
      // But if it's not empty and invalid (e.g. text), we might want to revert?
      // For number inputs, invalid input often returns "" as value.
      return
    }

    // Use the input's max attribute if available, otherwise default to 9999
    const max = parseInt(input.max) || 9999
    const min = parseInt(input.min) || 0
    
    if (value < min) {
      input.value = min
      value = min
    } else if (value > max) {
      input.value = max
      value = max
    }
    
    // Ensure the value in the input matches the sanitized value
    // This handles cases where the user types "007" -> "7" if we wanted, 
    // but mainly ensures the UI reflects the clamped value.
    if (input.value != value.toString()) {
       input.value = value
    }
  }
}
